import(/* webpackMode: "eager" */ "/Users/joseph/projects/moneyline/client/src/app/(public)/[sport]/scores/loading.tsx");
